import React, { useMemo } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { BadgeCheck, Menu, ShieldAlert } from 'lucide-react';
import UserAccountDropdown from '../common/UserAccountDropdown';
import NotificationBell from '../notifications/NotificationBell';
import NextLotRebateWidget from './NextLotRebateWidget';
import SystemNotificationBanner from '../SystemNotification/SystemNotificationBanner';
import ChallengeLoginModal from '../challenges/ChallengeLoginModal';
import { SuspendAccessGate } from '../AccessRestriction/featureGates';
import { useUser } from '../../contexts/UserContext';
import { useKycVerified } from '../../hooks/useKycVerified';
import '../../pages/kyc/kyc.css';

const PartnerPageLayout = () => {
  const { userData } = useUser();
  const { kycVerified } = useKycVerified();

  const userName = useMemo(() => {
    if (userData?.firstName) {
      return `${userData.firstName} ${userData.lastName || ''}`.trim();
    }
    if (userData?.fullName) return userData.fullName;
    return localStorage.getItem('userEmail')?.split('@')[0] || 'Partner';
  }, [userData]);

  const userEmail = userData?.email || localStorage.getItem('userEmail') || '';
  const userInitial = (userName[0] || 'P').toUpperCase();
  const affiliateCode =
    userData?.affiliateCode || localStorage.getItem('affiliateCode') || '';
  const userHandle = affiliateCode ? `@${String(affiliateCode).replace(/^@/, '')}` : '';

  return (
    <div className="min-h-full bg-[#F4F6F9]">
      <div className="sticky top-0 z-20 bg-[#F4F6F9] border-b border-gray-200/70 px-4 sm:px-6 py-3">
        <div className="nlr-header-bar">
          <button
            type="button"
            className="nlr-header-bar__menu p-2 rounded-lg hover:bg-white border border-transparent hover:border-gray-200 transition"
            onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))}
            aria-label="Toggle sidebar"
          >
            <Menu className="w-5 h-5 text-gray-600" />
          </button>
          <div className="nlr-header-bar__actions">
            {kycVerified ? (
              <span className="kyc-verified-badge" title="KYC verified">
                <BadgeCheck className="w-3.5 h-3.5" />
                Verified
              </span>
            ) : (
              <Link to="/kyc" className="kyc-nav-link" title="Complete KYC">
                <ShieldAlert className="w-3.5 h-3.5" />
                Not verified
              </Link>
            )}
            <NotificationBell />
            <UserAccountDropdown
              userName={userName}
              userEmail={userEmail}
              userInitial={userInitial}
              userHandle={userHandle}
            />
          </div>
          <div className="nlr-header-bar__timer">
            <NextLotRebateWidget />
          </div>
        </div>
      </div>

      <div className="pt-3">
        <SystemNotificationBanner />
      </div>

      <ChallengeLoginModal />

      <SuspendAccessGate>
        <Outlet />
      </SuspendAccessGate>
    </div>
  );
};

export default PartnerPageLayout;
